import { Autocomplete, TextField } from '@mui/material';
import type { ComponentProps, ReactNode } from 'react';
import { useTranslation } from 'react-i18next';
import { namedByPlaceholder } from '~/components/forms/autocomplete-label';
import type { SignalEventTypes__EventType } from './EventTypeAutocomplete.generated';

export interface EventTypeAutocompleteProps
  extends Omit<ComponentProps<typeof Autocomplete<number>>, 'options' | 'renderInput'> {
  error?: boolean;
  eventTypes: readonly SignalEventTypes__EventType[];
  helperText?: ReactNode;
  name?: string;
}

export const EventTypeAutocomplete = ({
  error,
  eventTypes,
  helperText,
  name,
  ...props
}: EventTypeAutocompleteProps) => {
  const { t } = useTranslation();

  return (
    <Autocomplete
      fullWidth
      getOptionLabel={(option) =>
        eventTypes.find((eventType) => eventType.id === option)?.name ?? ''
      }
      options={eventTypes.map((x) => x.id)}
      renderInput={(params) => (
        <TextField
          error={error}
          helperText={helperText}
          name={name}
          {...namedByPlaceholder(
            params,
            t('pages.device_signals.settings.placeholders.select_event_type'),
          )}
        />
      )}
      {...props}
    />
  );
};
